module.exports = __webpack_public_path__ + "img/company-chart.21143313.svg";